<div class="section-tickets-container">
  <!-- Opened Tickets Card -->
  <mat-card class="open-closed-card">
    @if (showTitles) {
      <div class="d-flex justify-content-center align-items-center">
        <div class="icon-container opened-tickets-icon-background">
          <img src="../../../../../assets/images/icons/open_tickets.svg" alt="" />
        </div>
        <p class="title opened-tickets-title">Opened Tickets</p>
      </div>
    }
    @for (type of dateRangeTypes; track type) {
      @if (dateRangeStates[type]?.loading) {
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '100%',
            height: '116px',
            'border-radius': '20px',
            'margin-bottom': '10px',
            background: 'var(--skeleton-background)',
          }"
        ></ngx-skeleton-loader>
      }
      @if (!dateRangeStates[type]?.loading && dateRangeStates[type]?.error) {
        <div class="section-error">
          <mat-icon>error_outline</mat-icon>
          <span>Failed to load {{ type }} data</span>
          <button class="retry-button" (click)="retryFetchDateRange(type)">Retry</button>
        </div>
      }
      @if (openedDateRangeMap[type]) {
        <div class="item opened-tickets-item">
          <span class="item-date">{{ openedDateRangeMap[type].label }}</span>
          <div class="d-flex justify-content-around w-100 align-items-center">
            <div class="d-flex flex-column align-items-center w-50">
              <span class="item-label">{{ openedDateRangeMap[type].label == 'Day' ? 'Yesterday' : 'Previous' }}</span>
              <span
                class="item-count"
                [class.has-items]="openedDateRangeMap[type].previous > 0"
                (click)="
                  filterByDateRange(
                    openedDateRangeMap[type].previousStartDate,
                    openedDateRangeMap[type].previousEndDate,
                    'Opened Tickets'
                  )
                "
                >{{ openedDateRangeMap[type].previous }}</span
              >
            </div>
            <div class="separator"></div>
            <div class="d-flex flex-column align-items-center w-50">
              <span class="item-label">{{ openedDateRangeMap[type].label == 'Day' ? 'Today' : 'Current' }}</span>
              <span
                class="item-count"
                [class.has-items]="openedDateRangeMap[type].current > 0"
                (click)="
                  filterByDateRange(
                    openedDateRangeMap[type].currentStartDate,
                    openedDateRangeMap[type].currentEndDate,
                    'Opened Tickets'
                  )
                "
                >{{ openedDateRangeMap[type].current }}</span
              >
            </div>
          </div>
          <div class="percentage opened-tickets-percentage-background">
            @if (openedDateRangeMap[type].percentage == 0) {
              <img src="../../../../../assets/images/icons/delta_null_icon.svg" alt="" />
            }
            @if (openedDateRangeMap[type].percentage != 0) {
              <img
                [ngClass]="{ rotated: openedDateRangeMap[type].percentage < 0 }"
                src="../../../../../assets/images/icons/delta_icon.svg"
                alt=""
              />
            }
            <span>{{ openedDateRangeMap[type].percentage }}%</span>
          </div>
        </div>
      }
    }
  </mat-card>

  <!-- Closed Tickets Card -->
  <mat-card class="open-closed-card">
    @if (showTitles) {
      <div class="d-flex justify-content-center align-items-center">
        <div class="icon-container closed-tickets-icon-background">
          <img src="../../../../../assets/images/icons/closed_tickets.svg" alt="" />
        </div>
        <p class="title closed-tickets-title">Closed Tickets</p>
      </div>
    }
    @for (type of dateRangeTypes; track type) {
      @if (dateRangeStates[type]?.loading) {
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '100%',
            height: '116px',
            'border-radius': '20px',
            'margin-bottom': '10px',
            background: 'var(--skeleton-background)',
          }"
        ></ngx-skeleton-loader>
      }
      @if (!dateRangeStates[type]?.loading && dateRangeStates[type]?.error) {
        <div class="section-error">
          <mat-icon>error_outline</mat-icon>
          <span>Failed to load {{ type }} data</span>
          <button class="retry-button" (click)="retryFetchDateRange(type)">Retry</button>
        </div>
      }
      @if (closedDateRangeMap[type]) {
        <div class="item closed-tickets-item">
          <span class="item-date">{{ closedDateRangeMap[type].label }}</span>
          <div class="d-flex justify-content-around w-100 align-items-center">
            <div class="d-flex flex-column align-items-center w-50">
              <span class="item-label">{{ closedDateRangeMap[type].label == 'Day' ? 'Yesterday' : 'Previous' }}</span>
              <span
                class="item-count"
                [class.has-items]="closedDateRangeMap[type].previous > 0"
                (click)="
                  filterByDateRange(
                    closedDateRangeMap[type].previousStartDate,
                    closedDateRangeMap[type].previousEndDate,
                    'Closed Tickets'
                  )
                "
                >{{ closedDateRangeMap[type].previous }}</span
              >
            </div>
            <div class="separator"></div>
            <div class="d-flex flex-column align-items-center w-50">
              <span class="item-label">{{ closedDateRangeMap[type].label == 'Day' ? 'Today' : 'Current' }}</span>
              <span
                class="item-count"
                [class.has-items]="closedDateRangeMap[type].current > 0"
                (click)="
                  filterByDateRange(
                    closedDateRangeMap[type].currentStartDate,
                    closedDateRangeMap[type].currentEndDate,
                    'Closed Tickets'
                  )
                "
                >{{ closedDateRangeMap[type].current }}</span
              >
            </div>
          </div>
          <div class="percentage closed-tickets-percentage-background">
            @if (closedDateRangeMap[type].percentage == 0) {
              <img src="../../../../../assets/images/icons/delta_null_icon.svg" alt="" />
            }
            @if (closedDateRangeMap[type].percentage != 0) {
              <img
                [ngClass]="{ rotated: closedDateRangeMap[type].percentage < 0 }"
                src="../../../../../assets/images/icons/delta_icon.svg"
                alt=""
              />
            }
            <span>{{ closedDateRangeMap[type].percentage }}%</span>
          </div>
        </div>
      }
    }
  </mat-card>
</div>
